module.exports = __webpack_public_path__ + "static/media/chevron-right.50bde396.svg";